import React, { Component } from 'react';
import EditorPage from '@componentes/editor/editor.page';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as editorActions from '@componentes/editor/editor.action';
import { editorPath, editorUrl} from '@constants/defaultValues';
import { getFontePadrao } from '../../../src/localStorage.util';

class EditorContainer extends Component {
  constructor (props) {
    super(props);
    this.handlerEvent = this.handlerEvent.bind(this);
    this.loading = true;
    this.state = {
      stringRtf: '',
      showPreview: false,
      intervalId: undefined,
    };
  }

  componentDidMount () {
    window.addEventListener('message-component', this.handlerEvent);
  }

  componentWillUnmount () {
    window.removeEventListener('message-component', this.handlerEvent);
  }

  getAltura = () => {
    return (
      document.getElementById('container-editor-component') &&
      document.getElementById('container-editor-component').style.height
    );
  };

  carregarEditor () {
    this.props.editorActions.editorInicializado(false);
    this.props.editorActions.editorCarregado(false);
    window.$editor_carregado = false;

    const frame = document.getElementById('iframe-editor-component');


    let idiomaEditor= '';

    switch (this.props.lang) {
      case 'es':
        idiomaEditor =  'es-ES';
        break;
       case 'en':
        idiomaEditor = 'en-US';
        break;
      default:
        idiomaEditor = 'pt-BR'
      }

    console.log('inicializando editor language:', idiomaEditor);

    if (frame !== null) {
      try {
        frame.contentWindow.postMessage(
          {
            method: 'inicializarEditor',
            language: idiomaEditor,
            urlHost: editorUrl,
            defaultFontName: getFontePadrao(),
            defaultFontSize: 12,
            defaultMargin: [2.5, 3, 2.5, 3], //[top, left, bottom, right] em centímetros Padrão ABNT
            initTextRtf: '',
						enableReferencesTab: false,
						enableViewTab: false,
            theme: 'Material',
            width: '100%',
            height: '630px',
            ribbonMode: 4,
            readOnly: false
          },
          editorUrl
        );

        frame.contentWindow.postMessage(
          {
            method: 'monitorarLifeCycle',
            urlHost: editorUrl
          },
          editorUrl
        );

      } catch (error) {
        console.log(error);
        this.carregarEditor();
      }
    }
  }

  handlerEvent = event => {
    if (
      `${event.origin}/${editorPath}` !==
      editorUrl
    ) {
      return;
    }

    if (event.data.type !== 'editor') {
      return;
    }
  };

  render () {

    return (
      <React.Fragment>
        <EditorPage
          alturaEditor={this.props.alturaEditor}
          carregarEditor={this.carregarEditor.bind(this)}
          showIconSave={this.state.showIconSave}
          showEditor={this.props.showEditor}
          larguraEditor={this.props.larguraEditor}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    lang: state.commonReducer.lang,
    alturaEditor: state.editorComponent.alturaEditor,
    detalhes: state.commonReducer.detalhes,
    editorCarregado: state.editorComponent.editorCarregado,
    editorInicializado: state.editorComponent.editorInicializado,
    showEditor: state.editorComponent.showEditor,
    textoInicial: state.editorComponent.textoInicial,
    etapaAtual: state.commonReducer.etapaAtual,
    larguraEditor: state.editorComponent.larguraEditor,
    status: state.editorComponent.status,
    mensagem: state.editorComponent.mensagem,
    tipo: state.editorComponent.tipo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    editorActions: bindActionCreators(editorActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditorContainer);



// WEBPACK FOOTER //
// ./src/componentes/editor/editor.container.js